/** Путь, куда вернуть пользователя после входа (ссылка на профиль актёра для кинокомпании) */
export const RETURN_TO_STORAGE_KEY = 'returnTo';
